import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TableDropdown = ({
  data,
  setDeleteBody,
  setToggleModal,
  setDataModal
}) => {
  const { t } = useTranslation();
  const currentRoute = useLocation().pathname;
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);
  const editLink = `${currentRoute}/${
    data.token ? data.token : data.id
  }/update/`;
  const viewStatLink = `${currentRoute}/${data.id}/view-stats`;
  const viewArtistDetailsLink = `${currentRoute}/${data.id}/view-details`;
  const artistDetailsAvailable = (data.spotify_identifier !== "" && data.spotify_identifier !==null)

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret outline color="primary">
        {t("general.tableDropdown.action")}
      </DropdownToggle>

      <DropdownMenu>
        {currentRoute === "/artists" ? (
          <>
            <DropdownItem
              disabled={data.is_blacklisted}
              onClick={() => {
                setDataModal(data);
                setToggleModal(true);
                setDeleteBody(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {t("general.tableDropdown.edit")}
            </DropdownItem>
            <DropdownItem
              disabled={data.is_blacklisted}
              onClick={() => {
                setDataModal(data);
                setToggleModal(true);
                setDeleteBody(true);
              }}
              style={{ cursor: "pointer" }}
            >
              {t("general.tableDropdown.delete")}
            </DropdownItem>
            {
              artistDetailsAvailable &&
              <DropdownItem
                style={{ cursor: "pointer" }}
              >
                <Link to={viewArtistDetailsLink}>{t("general.tableDropdown.viewDetails")}</Link>
              </DropdownItem>
            }
            <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(data.id)}}>{t("general.tableDropdown.copyMLId")}</DropdownItem>
          </>
        ) : (
          <>
            <DropdownItem>
              <Link to={editLink}>{t("general.tableDropdown.edit")}</Link>
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                setDataModal(data);
                setToggleModal(true);
                setDeleteBody(true);
              }}
              style={{ cursor: "pointer" }}
            >
              {t("general.tableDropdown.delete")}
            </DropdownItem>
            {(currentRoute === "/music-link" || currentRoute === "/link-landing-page") && <DropdownItem>
              <Link to={viewStatLink}>{t("general.tableDropdown.viewStats")}</Link>
            </DropdownItem>}
          </>
        )}
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default TableDropdown;
